export const REFETCH_INTERVAL_MS = 60_000;
export const LIVE_REFETCH_INTERVAL_MS = 30_000; // Live Ops polls faster
export const CLIENT_PAGE_SIZE = 10;

// v4 information architecture — a lean, focused 3-tab dashboard.
export const TABS = [
  { key: "analytics", label: "Analytics" },
  { key: "patients", label: "Patients" },
  { key: "doctors", label: "Doctors" },
  { key: "prescriptions", label: "Prescriptions" },
  { key: "alerts", label: "Alerts" },
  { key: "system", label: "System" },
];

export const DEFAULT_TAB = "analytics";

// Tabs whose data is real-time rather than range-windowed → hide the range pills.
export const NO_RANGE_TABS = ["system", "alerts"];

export const VISIT_STATUSES = ["Idle", "Pending", "Waiting", "Inprogress", "Closed", "Cancelled"];

export const VISIT_STATUS_TONES = {
  Waiting: "yellow",
  Inprogress: "green",
  Closed: "gray",
  Cancelled: "red",
  Pending: "gray",
  Idle: "gray",
};

export const DEFAULT_PATIENT_FILTERS = {
  status: "",
  stateId: "",
  from: "",
  to: "",
  search: "",
  page: 1,
};

export const STATUS_STYLES = {
  up: "bg-green-100 text-green-800",
  slow: "bg-yellow-100 text-yellow-800",
  down: "bg-red-100 text-red-800",
  unconfigured: "bg-gray-100 text-gray-500",
};
